export const paidPlansInstalled = (state = false) => state
